export enum ERecommendationStatus {
  DISPLAYED = 'displayed',
  TIMEOUT = 'timeout',
  ERROR = 'error',
  NO_RESULTS = 'no_results',
}
